import React from 'react';
import PropTypes from 'prop-types';

import LinearProgress from 'material-ui/LinearProgress';
import DetailView from '../Common/DetailView';
import { List } from 'material-ui/List';
import StatementListItem from '../LearningRecordStore/StatementListItem';

import InfoIcon from 'material-ui/svg-icons/action/info';
import EventIcon from 'material-ui/svg-icons/action/today';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';


import ActivityStore from '../../stores/ActivityStore';
import ModuleMediaStore from '../../stores/ModuleMediaStore';
import ModuleStore from '../../stores/ModuleStore';
import ModuleActions from '../../actions/ModuleActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

import LRS from '../../utils/LRS.js';
import { withId } from '../Common/Decorators';


const style = {
    list: {
        paddingBottom: 0,
    },
};

const getMenuItems = (id) => [
    {
        link: `/dashboard/module/${id}`,
        icon: <InfoIcon />,
        label: 'Preview',
    },
    {
        link: `/dashboard/module/${id}/events`,
        icon: <EventIcon />,
        label: 'Events',
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/module/${id}/enrolments`,
        icon: <EnrolmentIcon />,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.MANAGER]
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/module/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const ModuleActivity = React.createClass({

    getInitialState() {
        return {
            open: false,
            searchText: '',
            details: {
                name: '',
                description: '',
                duration: '',
                code: '',
                capacity: '',
                cost: '',
                price: '',
                type: '',
                validFrom: '',
                status: '',
                version: '',
            },
            activities: (<div><LinearProgress mode="indeterminate" /></div>),
            actions: [],
            links: {
                back: `/dashboard/module/${this.props.id}`,
                edit: '',

            }
        }
    },

    componentDidMount() {
        this.listeners = [
            ModuleStore.addListener(this.onModuleChange),
            ModuleMediaStore.addListener(this.onMediaInfoChange),
            ActivityStore.addListener(this.onActivityChange),
        ];
        ModuleActions.getById(this.props.id);
        this.setState({actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth)});
    },

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function(){

        return (

            <DetailView
                title='Activity'
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-list-wrapper">
                    <List style={style.list} className='cent-list'>
                        {this.state.activities}
                    </List>
                </div>
            </DetailView>

        );
    },

    onModuleChange: function(){
        const details = ModuleStore.getById(this.props.id);
        if (details !== undefined) {
            const code = details.uuid || details.code;
            this.setState({details});
            if (!!details.mediaId && code !== this.state.mediaId) {
                ModuleActions.getMediaInfo(code);
            }
        }
    },

    onMediaInfoChange: function() {
        const code = this.state.details.uuid || this.state.details.code;
        const mediaInfo = ModuleMediaStore.getById(code);
        if (mediaInfo !== undefined) {
            const stateChange = { mediaId: mediaInfo.id };
            if (mediaInfo.tinCanActivityId !== undefined && mediaInfo.tinCanActivityId !== '') {
                stateChange.moduleTinCan = mediaInfo.tinCanActivityId;
                if (this.context.auth.isAdmin()) {
                    LRS.getCourseActivity(mediaInfo.tinCanActivityId);
                } else {
                    LRS.getCourseActivity(mediaInfo.tinCanActivityId, this.context.auth.identity.id);
                }
            }
            this.setState(stateChange);
        }
    },

    onActivityChange: function() {
        let activities;
        if (this.state.moduleTinCan !== undefined && this.state.moduleTinCan !== '') {
            if (this.context.auth.isAdmin()) {
                activities = ActivityStore.getByCourse(this.state.moduleTinCan);
            } else {
                activities = ActivityStore.getByCourse(this.state.moduleTinCan, this.context.auth.identity.id);
            }
        } else {
            activities = ActivityStore.getByRegistration(this.state.tinCanList);
        }
        if (activities !== undefined && activities.length > 0) {
            const entries = activities
                .filter((attempt) => {
                    if (attempt !== undefined) {
                        let verb = attempt.verb.id.split('/').pop();
                        return verb === 'passed' || verb === 'failed';
                    }
                    return false;
                })
                .sort((a, b) => b.datetime - a.datetime)
                .map(attempt => <StatementListItem key={attempt.id} statement={attempt} />);
            this.setState({activities: entries});
        } else {
            this.setState({activities: null});
        }
    },


});

ModuleActivity.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(ModuleActivity);
